import { Avatar, theme } from '@salecycle/ui-component-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const StyledNameCell = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-start;
`;

const AvatarWrapper = styled.div`
  margin-right: 1rem;
`;

export interface IProps {
  id?: string;
  name: string;
  picture?: string;
  url: string;
}

export const NameCell: React.FC<IProps> = ({ id, name, picture, url, ...rest }: IProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <StyledNameCell {...rest}>
      <AvatarWrapper>
        <Avatar image={picture} size="small" bg={theme.vars.newColor.lightGS1} />
      </AvatarWrapper>

      <Link to={`${url}/${id}`} aria-label={t('userManagement.nameCellAriaLabel', { name })}>
        {name ? name : t('common.na')}
      </Link>
    </StyledNameCell>
  );
};

export default NameCell;
